/**
 * Description: Review page for the Audit Tool. 
 */
import React from 'react';
import {
  AppLayout
} from 'AWS-UI-Components-React';
import { CustomNavigation } from '../customNavigation.jsx';
import { JSClient } from '../common.jsx';
import { FilterBatchOutfits } from '../reviewPage/filterBatchOutfitsSection.jsx';
import { ReviewSection } from '../reviewPage/reviewSection.jsx';
import '../../styles/reviewpage.css';

export class Review extends React.Component {
  constructor(props) {
    super(props);
    this.reviewSection = React.createRef();
    this.state = { 
      initialLoadDone: false, 
      user: "", 
      auditBatchResult: [],
      filter_options: {
        created_after: "",
        created_before: "",
        outfit_source: "",
        marketplace: "0"
      },
      error: ""
    };
    this.clientLoaded = this.clientLoaded.bind(this);
    this.getAuditBatchCallBack = this.getAuditBatchCallBack.bind(this);
  }

  clientLoaded() {
    this.client.getIdentity(identityResult => {
        this.setState({ 
          user: identityResult.username,
          initialLoadDone: true 
        });
    });
  }

  componentWillMount() {
    this.client = new JSClient({ onReady: 
        this.clientLoaded
    });
  }

  getAuditBatchCallBack(filter_options) {
    return this.reviewSection.current.getNewAuditBatch(filter_options);
  }

  render() {
    if (!this.state.initialLoadDone) {
      return (
        <center>
          <h1>Authorizing user please wait...</h1>
        </center>
      );
    }

    const ReviewContent = () => (
      <div>
        <div id="filter">
          <FilterBatchOutfits getAuditBatchCallBack={this.getAuditBatchCallBack}/>
        </div>
        <div id="reviewSection">
          <ReviewSection 
          ref={this.reviewSection} 
          filter_options={this.state.filter_options} 
          user={this.state.user}/>
        </div>
      </div>
    );
    
    return (
      <div className="awsui">
        <AppLayout
          className='awsui-util-no-gutters'
          content={<ReviewContent />}
          navigation={<CustomNavigation />}
          toolsHide={true}
          navigationOpen={false}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/reviewPage/reviewpage.jsx